// auth.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { API_BASE_URL } from "./config";

type AuthCtx = {
  accessToken: string | null;
  language: string ;
  linkedCustomerId: string;
  setAccessToken: (t: string | null) => void;
  setLanguage: (t: string ) => void;
  initializing: boolean;
  login: (u: string, p: string) => Promise<void>;
  logout: () => Promise<void>;
};

const Ctx = createContext<AuthCtx | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [linkedCustomerId, setCustomer] = useState<string>("");
  const [language, setLanguage] = useState<string>("de");

  function parseJwt(token: string) {
    const [, payload] = token.split(".");
    return JSON.parse(atob(payload));
  }


  useEffect(() => {
    if (accessToken) {
      const payload = parseJwt(accessToken);
      setCustomer(payload.customerid.toString());
      setLanguage(payload.locale??"de");
    }
  }, [accessToken]);



  const [initializing, setInitializing] = useState(false);

  //this is for page reload
  useEffect(() => {
    (async () => {
      try {

        if(accessToken)
          return;
        //cookie is working now (only https, no localhost)
        //const t = sessionStorage.getItem("refreshToken");
        //if(!t || t=="")
        //  return;
        
        const res = await fetch(`${API_BASE_URL}/Auth/Refresh`, {
         method: "POST",
        //body: JSON.stringify(t),
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        });
        if (res.ok) {
             //const { accessToken: newToken, refreshToken: newRefreshToken } = await res.json();
             const { accessToken: newToken } = await res.json();
      if (!newToken) return;

          // store and retry original with the new token
          setAccessToken(newToken);
          //sessionStorage.setItem("refreshToken", newRefreshToken);
        } 
      } finally {
        setInitializing(false);
      }
    })();
  }, []);

  const login = async (username: string, password: string): Promise<void> => {
    const res = await fetch(`${API_BASE_URL}/Auth/Login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include", // receive refresh cookie
      body: JSON.stringify({ username, password }),
    });
    if (!res.ok) {
      const e = await res.text();
      throw new Error(e);
    }
    const data = await res.json();
    setAccessToken(data.accessToken);
    //sessionStorage.setItem("refreshToken", data.refreshToken);
  };

  const logout = async () => {
    
         setAccessToken(null);
         // sessionStorage.setItem("refreshToken", "");
   

    window.location.href = "/";
      
  };

  return (
    <Ctx.Provider value={{ accessToken, language, linkedCustomerId, setAccessToken, setLanguage, initializing, login, logout }}>
      {children}
    </Ctx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}
